import { cn } from "@/lib/utils";
import Flex from "./flex";
import { Text } from "./text";

interface SingleLineProps {
  icon?: any;
  contant: any;
  action?: any;
  iconWrapperClassName?: string;
  wrapperClassName?: string;
  contantClassName?: string;
  containerClassName?: string;
  [key: string]: any; // Index signature for additional props
}

const SingleLine = ({
  icon,
  contant,
  iconWrapperClassName,
  wrapperClassName,
  containerClassName,
  action,
  contantClassName,
  handleClick,
  className,
  ...rest
}: SingleLineProps) => {
  return (
    <>
      <Flex
        direction="row"
        justify={"between"}
        align={"center"}
        {...rest}
        onClick={handleClick}
        className={cn("px-xl py-s", wrapperClassName, className)}
      >
        <Flex align={"start"} className={containerClassName}>
          <div
            className={cn(
              "h-5 w-5 text-center mr-m-nudge flex justify-center items-center ",
              iconWrapperClassName
            )}
          >
            {/* icon */}
            {icon}
          </div>

          <Flex direction="col" className={`flex justify-end ${contantClassName}`}>
            {/* Title */}
            <Text as="div" variant={"body_two"}>
              {contant}
            </Text>
            {/* subtext */}
          </Flex>
        </Flex>
        <div>
          {/* Right Action */}
          {action}
        </div>
      </Flex>
    </>
  );
};

export default SingleLine;
